import { LOGIN_STEP, URL_SOURCE_TYPE } from "./enums";

import { ROUTES } from "./enums";

import { Gender } from "./enums";
import { CustomInputType } from "./types";

export const COOLDOWN_PERIOD = 10000; // 10 seconds
// export const isMobile = window.matchMedia("(max-width: 640px)").matches;
export const FULL_URL = process.env.REACT_APP_FULL_URL;
export const EXTERNAL_URL = process.env.REACT_APP_EXTERNAL_URL;
export const GLOBAL_BLUE_THIRD_PARTY_LINK = "https://www.globalblue.com/en";
export const GLOBAL_BLUE_PRIVACY_POLICY_LINK =
  "https://www.globalblue.com/en/shoppers/legal-information/privacy-policy";
export const ACTIVATE_CARD_TERMS_OF_USE_LINK =
  "https://www.passportcard.co.il/financial-services/terms-of-use/";
export const ACTIVATE_CARD_SERVICE_RATES_LINK =
  "https://www.passportcard.co.il/financial-services/service-rates/";

export const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.passportcard.pfs";
export const IOS_URL = "https://apps.apple.com/app/id6480104130";

export const uiCustomData = {
  uiCustomData: {
    disableTxnRedirectPopup: true,
    disableRetryOnFailure: true,
    skipPaymentMethodsScreen: true,
    uiLang: "heb",
    customText: {
      "cg-submit-btn": "הוספת כרטיס",
      "label-expYear": "תוקף",
      "label-card-number": "מספר כרטיס",
      "expYear-ph": "שנה",
      "expMonth-ph": "חודש",
      "label-cvv": "3 ספרות בגב הכרטיס",
      "error-card-number": "מספר כרטיס לא תקין",
    },
    customStyle:
      ":root{--cg-prime:#1C2333;" +
      "--cg-second:#5c64ff;" +
      "--cg-turquois:#0EAAD1;" +
      "--cg-suc:transparent;" +
      "--cg-err:#EE4D3B;" +
      "--cg-gray:#B9B9BA;" +
      "--cg-lightgray:#F6F6F6" +
      "}" +
      "*{direction:rtl;}" +
      "app-number-of-payments{display:none!important;}" +
      "#cg-business-logo {width:1px}" +
      "#cg-clear,#cg-footer,#cg-secure-payment,#cg-shadow,#cg-tx-form.cg-block-title,#cg-tx-info,#shield-icon,app-root>img:first-child{display:none!important}" +
      "#cg-tx-container,#cg-tx-data,#cg-tx-form{padding:0!important;border:none!important;}" +
      "#cg-form{justify-content:space-between;}" +
      "#cg-section{overflow:hidden;min-height:unset!important;}" +
      "#cg-container{border:none;border-radius:0;background-color:transparent!important}" +
      "#cg-section,#cg-tx-container,#cg-popup-wrapper{background:transparent!important;}" +
      "#cg-header{position:absolute;bottom:48px;}" +
      "#cg-header-wrapper{height:48px;padding:0;}" +
      "#cg-header,#cg-header-wrapper,#logo-icon{background:transparent;border-bottom:none;width:315px;}" +
      "#cg-tx-container{border-radius:0;margin:0 auto;margin-top:15px;}" +
      "#cg-tx-form{position:relative;right:5px;}" +
      "#cg-tx-form{min-height:0!important;right:unset!important;}" +
      "#cg-form-title, .text-danger {display:none}" +
      "#cg-tx-form .form-group,.form-control-label{color:#525355;}" +
      ".form-group{margin:0;}" +
      "#cg-tx-form .cg-input{color:#525355; border-radius: 64px; border: 1px solid #DFDFDF;height:46px;padding: 0 28px;text-align:right;}" +
      "#cg-tx-form .cg-group-input input,select{background:#fff; height:46px; color: #1D1C1D;font-size: 16px; appearance: none!important;}" +
      "#cg-tx-form lib-field-builder {margin-bottom:20px}" +
      "#cg-tx-form :focus{outline:0;border-color:#b9b9ba!important}" +
      "#cg-tx-form :focus{outline:0;border-color:#b9b9ba!important}" +
      "#cg-tx-form .ng-valid{border-color:var(--cg-suc)}#cg-tx-form lib-field-builder:not(#cg-form-group-card-number),.col-5,.col-3 .col-6{flex:unset;max-width: 48%;}" +
      ".cg-label-input {margin-inline-start: 10px;}" +
      ".cg-message-input {text-align: start; padding-inline-start: 15px;}" +
      "form #cg-card-brand {left: 20px}" +
      "select {position: relative; appearance: none!important;}" +
      "lib-dropdown::after {font-family: monospace;font-size: 1rem;left: 26px;top: 39px;position: absolute; border-style: solid; border-width: 1px 1px 0 0;display:inline-block; height: 10px; vertical-align: top; width:10px;transform: rotate(135deg) }" +
      "#cg-submit-btn{;background:#e10514;margin:15px auto 0; width: 215px;border-radius: 50px;font-weight: 400;}" +
      "#cg-submit-btn,:active :hover{color:#fff;border-color:#fff;}" +
      "lib-transaction-alert-popup{background-color:#0d1718;border-radius:15px!important;}" +
      "#cg-popup-wrapper{height:unset!important;width:unset!important;}" +
      "#cg-popup-wrapper *{color:white!important;}" +
      "#cg-popup-cancel p{padding:0!important;font-size:14px!important;}" +
      "#cg-popup-cancel span{display:block!important;}" +
      "#cg-popup-title{font-size:25px!important;}" +
      "#cg-popup-p{font-size:16px!important;}" +
      "#cg-popup-wrapper .primary-cg-button{background:#e10514!important;font-size:14px!important;}" +
      "#cg-popup-content{padding:25px 0;}" +
      "#cg-popup-anim{display:none;}" +
      ".primary-cg-button:not([disabled]):hover{background:#e10514!important;border:none!important;}" +
      "#cg-payment-related{margin:0!important}.cg-form-controls{margin:0;}" +
      "@media (min-width: 464px) {" +
      "#cg-tx-form ,#cg-form-group-card-number .form-group, #cg-tx-form  .form-control-label #cg-tx-form  .form-control-label, #cg-form {width: 464px; max-width: 464px;}" +
      "#cg-tx-form lib-field-builder:not(#cg-form-group-card-number), .col-5, .col-3 .col-6 { width: 147px;}" +
      "}",
  },
};



export const monthNames: { [key: number]: string } = {
  1: "ינואר",
  2: "פברואר",
  3: "מרץ",
  4: "אפריל",
  5: "מאי",
  6: "יוני",
  7: "יולי",
  8: "אוגוסט",
  9: "ספטמבר",
  10: "אוקטובר",
  11: "נובמבר",
  12: "דצמבר",
};

// מספרים סודרים (Ordinal Numbers) בעברית
export const ordinalNumbers: { [key: number]: string } = {
  1: "הראשון",
  2: "השני",
  3: "השלישי",
  4: "הרביעי",
  5: "החמישי",
  6: "השישי",
  7: "השביעי",
  8: "השמיני",
  9: "התשיעי",
  10: "העשירי",
  11: "האחד עשר",
  12: "השניים עשר",
  13: "השלושה עשר",
  14: "הארבעה עשר",
  15: "החמישה עשר",
  16: "השישה עשר",
  17: "השבעה עשר",
  18: "השמונה עשר",
  19: "התשעה עשר",
  20: "העשרים",
  21: "העשרים ואחד",
  22: "העשרים ושניים",
  23: "העשרים ושלושה",
  24: "העשרים וארבעה",
  25: "העשרים וחמישה",
  26: "העשרים ושישה",
  27: "העשרים ושבעה",
  28: "העשרים ושמונה",
  29: "העשרים ותשעה",
  30: "השלושים",
  31: "השלושים ואחד",
};


// יחידות, עשרות ומאות בזכר/נקבה
export const unitNumbers = {
  [Gender.MALE]: ["אחד", "שני", "שלושה", "ארבעה", "חמישה", "שישה", "שבעה", "שמונה", "תשעה"],
  [Gender.FEMALE]: ["אחת", "שתי", "שלוש", "ארבע", "חמש", "שש", "שבע", "שמונה", "תשע"],
  [Gender.COLLECTIVE]: ["אחד", "שניים", "שלושה", "ארבעה", "חמישה", "שישה", "שבעה", "שמונה", "תשעה"],
};

export const tensNumbers = ["עשר", "עשרים", "שלושים", "ארבעים", "חמישים", "שישים", "שבעים", "שמונים", "תשעים"];
export const hundredsNumbers = ["מאה", "מאתיים", "שלוש מאות", "ארבע מאות", "חמש מאות", "שש מאות", "שבע מאות", "שמונה מאות", "תשע מאות"];
// export const location = window.location;
// export const currentSource = location.pathname.split("/")[1].toLowerCase(); // ensure, sms,campaign,rep_manual ect
// console.log("currentSource ###", currentSource);
// export const step = location.pathname.split("/")[2]?.toLowerCase();
// console.log("step ###", step);
// export const child = location.pathname.split("/")[3]?.toLowerCase();
// console.log("child ###", child);
// export const prefix = `/${currentSource}/${step}/`.toLowerCase();
// console.log("prefix ###", prefix);

// export const LOGIN_PATHS = {
//   LOGIN_DETAILS: `${prefix}${ROUTES.LOGIN_DETAILS}`,
//   LOGIN_OTP: `${prefix}${ROUTES.LOGIN_OTP}`,
//   CHOOSE_POLICY: `${prefix}${ROUTES.LOGIN_CHOOSE_POLICY}`,
//   UPDATE_CONTACT_DETAILS: `${prefix}${ROUTES.UPDATE_CONTACT_DETAILS}`,
//   FULL_LOGIN_OTP: `/${currentSource}${LOGIN_STEP.OTP}`,
//   PC_PLUS_SCREEN: `${prefix}${ROUTES.PC_PLUS_SCREEN}`,
// } as const;

export const pcPlusRoutes = [
  URL_SOURCE_TYPE.SMS,
  URL_SOURCE_TYPE.MARKETING,
  URL_SOURCE_TYPE.CAMPAIGN,
  URL_SOURCE_TYPE.SMS_SHARE,
  URL_SOURCE_TYPE.ENSURE,
  URL_SOURCE_TYPE.PFS_REP,
  URL_SOURCE_TYPE.APP,
];
export const eligibilityRoutes = [
  URL_SOURCE_TYPE.SALES_REP,
  URL_SOURCE_TYPE.DIGITAL,
  URL_SOURCE_TYPE.SMS,
  URL_SOURCE_TYPE.MARKETING,
  URL_SOURCE_TYPE.CAMPAIGN,
  URL_SOURCE_TYPE.REP_MANUAL,
  URL_SOURCE_TYPE.APP,
];
export const ARIA_LABEL: Record<CustomInputType, string> = {
  id: "מספר תעודת זהות",
  phone: "מספר טלפון",
  otp: "מספר OTP (קוד שנשלח אליך לנייד)",
} as const;

export const ARIA_LABEL_CELL: Record<CustomInputType, string> = {
  id: "תעודת זהות",
  phone: "טלפון",
  otp: "קוד",
} as const;